import store from '../store';
import { SLOTS_HOLD_DELETE } from '../store/_commons';

export default {
    showTimerExpiredModal() {
        return new Promise(resolve => {
            const data = {
                header: 'Your reservation hold has expired',
                title: 'You\'ve reached the end of the time allotted to hold your reservation.',
                description: 'If you would like to make a reservation please select a date and time again to start a new reservation hold.',
                primaryButtonText: store.state.user.LANG.btnSelectDateTime,
                secondaryButtonText: store.state.user.LANG.btnResHome,
                modalType: 'expired',
                onSecondaryButtonClick: () => {
                    resolve(true); // User confirmed, proceed with navigation
                },
                onPrimaryButtonClick: () => {
                    resolve(false); // User canceled, cancel navigation
                }
            }
            store.commit('user/setState', { property: 'showModalAlert', value: true });
            store.commit('user/setState', { property: 'modalDetails', value: data });
        });
    },
    showNavigateAwayModal() {
        return new Promise(resolve => {
            const data = {
                header: 'You will lose your reservation hold',
                title: 'If you choose to navigate to a previous screen you will lose the hold on this reservation.',
                description: 'Would you like to navigate away from this screen or continue with this reservation?',
                primaryButtonText: store.state.user.LANG.btnContinueRes,
                secondaryButtonText: store.state.user.LANG.btnLeave,
                modalType: 'navigate',
                // targetRoute: to // Store the target route to push to late
                onSecondaryButtonClick: async () => {
                    await store.dispatch(SLOTS_HOLD_DELETE);
                    resolve(true); // User clicked 'Leave' and slot was removed, proceed with navigation
                },
                onPrimaryButtonClick: () => {
                    resolve(false); // User clicked 'Continue', cancel navigation
                }
            }
            store.commit('user/setState', { property: 'showModalAlert', value: true });
            store.commit('user/setState', { property: 'modalDetails', value: data });
        });
    },
    hideModal() {
        store.commit('user/setState', { property: 'showModalAlert', value: false });
    },
    showNavigateAwayModalMfa() {
        return new Promise(resolve => {
            const data = {
                header: 'You will have to re-verify your contact information',
                title: 'If you choose to navigate to the previous screen you will have to re-verify your contact information.',
                primaryButtonText: store.state.user.LANG.btnContinueRes,
                secondaryButtonText: store.state.user.LANG.btnLeave,
                modalType: 'navigateToMfa',
                // targetRoute: to // Store the target route to push to late
                onSecondaryButtonClick: () => {
                    resolve(true); // User confirmed, proceed with navigation
                },
                onPrimaryButtonClick: () => {
                    resolve(false); // User canceled, cancel navigation
                }
            }
            store.commit('user/setState', { property: 'showModalAlert', value: true });
            store.commit('user/setState', { property: 'modalDetails', value: data });
        });
    }
};